<script>
import categoryForm from './category-form'

export default {
  name: 'CategoryNew',
  page: {
    title: 'New Category',
  },
  components: {
    categoryForm,
  },
}
</script>

<template>
  <main-layout
    title="New Category"
    :back="{ name: 'categories' }"
  >
    <data-box :status="false">
      <category-form />
    </data-box>
  </main-layout>
</template>
